import {
  Typography,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";
import React from "react";
import { Link } from "react-router-dom";

const Dropdown = ({ category, dropdownData }) => {
  return (

    // dropdown start 
    <Menu placement="bottom-start">
      <MenuHandler>
        <p
          variant="gradient"
          className="border-2 border-transparent hover:border-b-2 hover:border-b-[#f4d6d6] transition duration-300 cursor-pointer  text-sm font-semibold text-[#f4d6d6]"
        >
          {category}
        </p>
      </MenuHandler>
      <MenuList className="bg-[#F4C5C5] border-none shadow-xl p-5">
        {dropdownData?.map((item, i) => (
          <Link to={`/products${item?.link}`} key={i}>
            <MenuItem className="uppercase hover:bg-orange-200 py-2 text-white">
              {item.name}
            </MenuItem>
          </Link>
        ))}
      </MenuList>
    </Menu>
  );
};

export default Dropdown;


// old dropdown 
// <div className="dropdown">
//   <Typography
//     as="li"
//     variant="small"
//     color="blue-gray"
//     className="p-1 font-normal"
//   >
//     <a
//       href="#"
//       className="flex items-center border-2 border-transparent hover:border-b-2 hover:border-b-white text-white transition duration-150 "
//     >
//       {category}
//     </a>
//   </Typography>
//   <ul
//     tabIndex={0}
//     className="dropdown-content menu p-2 shadow rounded-box w-52 bg-[#F4C0C0]"
//   >
//     {dropdownData?.map((item, i) => (
//       <Link to={`/products${item?.link}`} key={i}>
//         <li>
//           <a className="uppercase text-white">{item?.name}</a>
//         </li>
//       </Link>
//     ))}
//   </ul>
// </div>


